export function formatPhone(phone: string): string {
  const ru = /^\+7(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(phone);
  return ru ? `+7 ${ru[1]} ${ru[2]}-${ru[3]}-${ru[4]}` : phone;
}

export function phoneForCopy(phone: string): string {
  const digits = phone.replace(/[^\d+]/g, '');
  return /^8\d{10}$/.test(digits) ? `+7${digits.slice(1)}` : digits;
}
